import React, { useEffect, useState } from 'react'
// import * as Yup from 'yup'
import { useFormik } from 'formik'
import Switch from "../../../../../../../../../core/Switch"
import Svg from '../../../../../../../../../component/common/Svg'
import Callout from '../../../../../../../../../core/Callout'
import iicon from '../../../../../../../../../assets/images/i-icon.png'
import Input from "../../../../../../../../../core/Inputs/DefaultInput"
import { useDispatch } from 'react-redux'
import style from "../../../../../../../../style.module.css";
import { getTokenData } from '../../../../../../../../../store/actions/authAction'
import { updateQuestion, updateQuestionControl, updateQuestionHint } from '../../../../../../../../../store/actions/qnaBuilderAction'

const OpinionScalePreview = ({ survey_id, questionId, setIsVisibleCollapse, language_code, questionIndex, isVisibleCollapse, collapseMode, setCollapseMode, collapseModes, question }) => {

  //==> STATES <==
  const [questionText, setQuestionText] = useState(null)
  const [userId, setuserId] = useState('');

  const options = ['Worst', 'Bad', 'Neutal', 'Good', 'Best']
  const icons = ['circle', 'star', 'thumb', 'face']

  //Others
  const dispatch = useDispatch()

  //==> FORM SCHEMA AND VALIDATION <==

  //Formik
  const initialValues = {
    options: {},
    score: {},
    range: { start: 1, end: 5 },
    icon: 1,
    hint: ''
  }

  const formik = useFormik({
    initialValues: initialValues,
  })

  const {
    values,
    handleChange,
    handleBlur,
    touched,
    errors,
    resetForm,
    setValues,
    setFieldValue,
    setFieldTouched,
  } = formik


  //==> FUNCTIONALITIES <==

  //Handle view chage
  const handleViewChange = (mode) => {
    setCollapseMode(mode)
  }

  const handleCancel = () => {
    setIsVisibleCollapse(false)
    setInitialData()
  }

  const handleSave = (options, score) => {
    const payloadOption = {
      qid: questionId,
      qtxt: questionText,
      qtype: 3,
      qopts: {
        common: {
          opinionScore: score
        },
        opinionOptionsText: {
          22: options
        }
      },
      qorderno: questionIndex,
      qsection: question.sectionId,
      added_by: userId,
      qsurvey: survey_id,
      language_code: language_code
    }
    dispatch(updateQuestion(payloadOption, afterSave))
  }

  const afterSave = () => {
    setCollapseMode(collapseModes.preview)
  }

  const setInitialData = () => {
    let tmpScore = question?.options?.common?.opinionScore
    let tmpOptions = question?.options?.opinionOptionsText
    tmpOptions = tmpOptions && tmpOptions[language_code]

    if (tmpOptions && tmpScore) {
      let option = {}
      let score = {}
      let tmptouched = {}
      Object.keys(tmpOptions ?? {})?.forEach((key, index) => {
        option[index] = tmpOptions[key]
        score[index] = tmpScore[key]
        tmptouched[index] = false
      })

      setFieldValue('score', score)
      setFieldValue('options', option)
      setFieldTouched('options', tmptouched)
      setFieldTouched('score', tmptouched)
    }
    else {
      let tmptouched = {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
      }

      let values = {
        0: options[0],
        1: options[1],
        2: options[2],
        3: options[3],
        4: options[4]
      }

      let scores = {
        0: '',
        1: '',
        2: '',
        3: '',
        4: ''
      }
      setFieldValue('score', scores)
      setFieldValue('options', values)
      setFieldTouched('options', tmptouched)
      setFieldTouched('score', tmptouched)
    }
  }

  const handleChangeRange = (e, key) => {
    setFieldValue('range', { ...values?.range, [key]: e.target.value })
    const payload = {
      column: 'su_opinion_range',
      value: JSON.stringify({ ...values?.range, [key]: e.target.value }),
      question_id: questionId
    }
    dispatch(updateQuestionControl(payload))
  }

  const handleChangeIcon = (key, value) => {
    setFieldValue(key, value)
    const payload = {
      column: 'su_opinion_icon',
      value: value,
      question_id: questionId
    }
    dispatch(updateQuestionControl(payload))
  }

  const handleIsRequired = (e) => {
    const payload = {
      column: e.target.value,
      value: (e.target.checked) ? 1 : 0,
      question_id: questionId
    }
    dispatch(updateQuestionControl(payload))
  }

  const handleIsScore = (e) => {
    const payload = {
      column: e.target.value,
      value: (e.target.checked) ? 1 : 0,
      question_id: questionId
    }
    dispatch(updateQuestionControl(payload))
  }

  const handleUpdateQuestionHint = (id, text) => {
    const payload = {
      language_code: language_code,
      id,
      text
    }
    dispatch(updateQuestionHint(payload))
  }

  const handleBlurQuestionHint = (e, { questionId }, text) => {
    handleBlur(e)
    handleUpdateQuestionHint(questionId, text)
  }


  //==> Effects <==
  useEffect(() => {
    if (question) {
      setInitialData()
      setQuestionText(question.questionText)
      setFieldValue('hint', question?.questionHint ?? '')

      if (question.opinionRange) {
        if (question.opinionRange?.end && question.opinionRange?.start)
          console.log('question.opinionRange', question.opinionRange)
        setFieldValue('range', { start: Number(question.opinionRange?.start), end: Number(question.opinionRange?.end) })
      }
      question.opinionIcon && setFieldValue('icon', Number(question.opinionIcon))
    }
  }, [language_code, question])

  useEffect(() => {
    dispatch(getTokenData(setuserId))
  }, [userId, dispatch])

  return (
    <div
      className={`${isVisibleCollapse ? 'show' : ''} accordion-collapse collapse`}
      data-bs-parent="#surveyaccordian">
      <div className="accordion-body">

        {/*Edit Version */}
        {collapseMode === collapseModes?.edit && <div className="editor-wrap">
          <div className='choices-full-width'>
            
            <>
              {(isVisibleCollapse && collapseMode === collapseModes.edit) && <>
                <div className="text mb-3">
                  <Input
                    type="text"
                    view="outlined"
                    color="default"
                    label=""
                    placeholder={'Please enter hint'}
                    value={values.hint}
                    onClick={((e) => e.stopPropagation())}
                    fill
                    name='hint'
                    onChange={window.modulePermissions.M11.edit == 1 ? handleChange : undefined}
                    onBlur={window.modulePermissions.M11.edit == 1 ? (e) => { handleBlurQuestionHint(e, question, values.hint) } : undefined}
                    readOnly={window.modulePermissions.M11.edit != 1}
                    className={"formsinput " + style.card__exp}
                  />
                </div>
              </>
              }
            </>
            <div className='d-flex align-items-center'>
              <div className="multiple-edit-sec p-0 flex-grow-1">
                <div className="input-score-wrap">
                  <div className="input-wrap d-flex flex-wrap align-items-center mb-4">
                    <div className="title">Input</div>
                    <div className="choices d-flex align-items-center justify-content-between">
                      {
                        Object.keys(values?.options ?? {})?.map((key, index) => {
                          if (index + 1 >= Number(values?.range?.start) && index + 1 <= Number(values?.range?.end)) {
                            return (
                              <div className="choice-wrap" key={key} >
                                <div className="choices-score d-flex align-items-center">
                                  <Input
                                    type='text'
                                    view='outlined'
                                    dense={false}
                                    color='default'
                                    label=''
                                    placeholder='Option Here'
                                    success={false}
                                    error={false}
                                    fill={true}
                                    errorHelperText={null}
                                    className={"formsinput"}
                                    value={values?.options[key] ?? ''}
                                    onChange={window.modulePermissions.M11.edit == 1 ? (e) => setFieldValue('options', { ...values?.options, [key]: e.target.value }) : undefined}
                                    onBlur={window.modulePermissions.M11.edit == 1 ? () => setFieldTouched('options', { ...touched?.options, [key]: true }) : undefined}
                                    readOnly={window.modulePermissions.M11.edit != 1}
                                  />
                                  {touched.options && touched.options[key] && values.options && values.options[key] === '' && <span>Required</span>}
                                </div>
                              </div>
                            )
                          }
                          return ''
                        })
                      }

                      {/* <div className="choice-wrap">
                        <div className="choices-score d-flex align-items-center">
                          <Input
                            type='text'
                            view='outlined'
                            dense={false}
                            color='default'
                            label=''
                            placeholder='Option Here'
                            success={false}
                            value={'Bad'}
                            error={false}
                            fill={true}
                            errorHelperText={null}
                            className={"formsinput"}
                          />
                        </div>
                      </div>
                      <div className="choice-wrap">
                        <div className="choices-score d-flex align-items-center">
                          <Input
                            type='text'
                            view='outlined'
                            dense={false}
                            color='default'
                            label=''
                            placeholder='Option Here'
                            success={false}
                            value={'Neutal'}
                            error={false}
                            fill={true}
                            errorHelperText={null}
                            className={"formsinput"}
                          />
                        </div>
                      </div>
                      <div className="choice-wrap">
                        <div className="choices-score d-flex align-items-center">
                          <Input
                            type='text'
                            view='outlined'
                            dense={false}
                            color='default'
                            label=''
                            placeholder='Option Here'
                            success={false}
                            value={'Good'}
                            error={false}
                            fill={true}
                            errorHelperText={null}
                            className={"formsinput"}
                          />
                        </div>
                      </div>
                      <div className="choice-wrap">
                        <div className="choices-score d-flex align-items-center">
                          <Input
                            type='text'
                            view='outlined'
                            dense={false}
                            color='default'
                            label=''
                            placeholder='Option Here'
                            success={false}
                            value={'Best'}
                            error={false}
                            fill={true}
                            errorHelperText={null}
                            className={"formsinput"}
                          />
                        </div>
                      </div> */}

                    </div>
                  </div>
                  {Number(question?.isScore) === 1 && <div className="scores-wrap d-flex flex-wrap align-items-center">
                    <div className="title">Score</div>
                    <div className="choices d-flex align-items-center justify-content-between">
                      {
                        Object.keys(values?.score ?? {})?.map((key, index) => {
                          if (index + 1 >= Number(values?.range?.start) && index + 1 <= Number(values?.range?.end)) {
                            return (
                              <div className="choice-wrap text-center" key={key}>
                                <Input
                                  type='number'
                                  view='outlined'
                                  dense={false}
                                  color='default'
                                  label=''
                                  success={false}
                                  error={false}
                                  fill={true}
                                  errorHelperText={null}
                                  className={"formsinput"}
                                  value={values?.score[key] ?? ''}
                                  onChange={window.modulePermissions.M11.edit == 1 ? (e) => setFieldValue('score', { ...values?.score, [key]: e.target.value }) : undefined}
                                  onBlur={window.modulePermissions.M11.edit == 1 ? () => setFieldTouched('score', { ...touched?.score, [key]: true }) : undefined}
                                  readOnly={window.modulePermissions.M11.edit != 1}
                                />
                                {touched.score && touched.score[key] && values.score && values.score[key] === '' && <span>Required</span>}
                              </div>
                            )
                          }
                        })
                      }
                      {/* <div className="choice-wrap text-center">
                        <Input
                          type='text'
                          view='outlined'
                          dense={false}
                          color='default'
                          label=''
                          success={false}
                          value={'5'}
                          error={false}
                          fill={true}
                          errorHelperText={null}
                          className={"formsinput"}
                        />
                      </div>
                      <div className="choice-wrap text-center">
                        <Input
                          type='text'
                          view='outlined'
                          dense={false}
                          color='default'
                          label=''
                          success={false}
                          value={'5'}
                          error={false}
                          fill={true}
                          errorHelperText={null}
                          className={"formsinput"}
                        />
                      </div>
                      <div className="choice-wrap text-center">
                        <Input
                          type='text'
                          view='outlined'
                          dense={false}
                          color='default'
                          label=''
                          success={false}
                          value={'5'}
                          error={false}
                          fill={true}
                          errorHelperText={null}
                          className={"formsinput"}
                        />
                      </div>
                      <div className="choice-wrap text-center">
                        <Input
                          type='text'
                          view='outlined'
                          dense={false}
                          color='default'
                          label=''
                          success={false}
                          value={'5'}
                          error={false}
                          fill={true}
                          errorHelperText={null}
                          className={"formsinput"}
                        />
                      </div> */}
                    </div>
                  </div>}
                </div>
              </div>
              <div className="button-wrap d-flex add-cancel-btn mt-0 ps-3">
                <div className="action-buttons d-flex">
                  <button className='btn btn-bordered' onClick={() => handleCancel()}>Cancel</button>
                  {window.modulePermissions.M11.edit == 1 && <button className='btn btn-primary' onClick={() => handleSave(values.options, values.score)}>Save</button>}
                </div>
              </div>

            </div>
          </div>
        </div>}

        {/* Preview Wrap */}
        {collapseMode === collapseModes?.preview && <div className='d-flex flex-wrap flex-column question-preview-pg'>
          <div className="preview-header">
            <div className="radio-btn-screen d-inline-flex align-items-center justify-content-center">
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="screenSize" id="Desktop" defaultValue="Desktop" defaultChecked />
                <label className="form-check-label" htmlFor="Desktop" title="Desktop">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 17H21C22.1046 17 23 16.1046 23 15V5C23 3.89543 22.1046 3 21 3H3C1.89543 3 1 3.89543 1 5V15C1 16.1046 1.89543 17 3 17H12ZM12 17V21M12 21H16M12 21H8" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>


                </label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="screenSize" id="Tablet" defaultValue="Tablet" />
                <label className="form-check-label" htmlFor="Tablet" title="Tablet">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM6 1.75H18V0.25H6V1.75ZM19.25 3V21H20.75V3H19.25ZM4.75 21V3H3.25V21H4.75ZM18 22.25H6V23.75H18V22.25ZM11 19.75H13V18.25H11V19.75ZM3.25 21C3.25 22.5188 4.48122 23.75 6 23.75V22.25C5.30964 22.25 4.75 21.6904 4.75 21H3.25ZM19.25 21C19.25 21.6904 18.6904 22.25 18 22.25V23.75C19.5188 23.75 20.75 22.5188 20.75 21H19.25ZM18 1.75C18.6904 1.75 19.25 2.30964 19.25 3H20.75C20.75 1.48122 19.5188 0.25 18 0.25V1.75ZM6 0.25C4.48122 0.25 3.25 1.48122 3.25 3H4.75C4.75 2.30964 5.30964 1.75 6 1.75V0.25Z" fill="#0F2744" />
                  </svg>
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="screenSize" id="Mobile" defaultValue="Mobile" />
                <label className="form-check-label" htmlFor="Mobile" title="Mobile">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 18.25C10.5858 18.25 10.25 18.5858 10.25 19C10.25 19.4142 10.5858 19.75 11 19.75V18.25ZM13 19.75C13.4142 19.75 13.75 19.4142 13.75 19C13.75 18.5858 13.4142 18.25 13 18.25V19.75ZM8 1.75H16V0.25H8V1.75ZM17.25 3V21H18.75V3H17.25ZM6.75 21V3H5.25V21H6.75ZM16 22.25H8V23.75H16V22.25ZM11 19.75H13V18.25H11V19.75ZM5.25 21C5.25 22.5188 6.48122 23.75 8 23.75V22.25C7.30964 22.25 6.75 21.6904 6.75 21H5.25ZM17.25 21C17.25 21.6904 16.6904 22.25 16 22.25V23.75C17.5188 23.75 18.75 22.5188 18.75 21H17.25ZM16 1.75C16.6904 1.75 17.25 2.30964 17.25 3H18.75C18.75 1.48122 17.5188 0.25 16 0.25V1.75ZM8 0.25C6.48122 0.25 5.25 1.48122 5.25 3H6.75C6.75 2.30964 7.30964 1.75 8 1.75V0.25Z" fill="#0F2744" />
                  </svg>
                </label>
              </div>
              <div className="form-check form-check-inline">
                <button className="full-screen-btn" title="View full screen">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 18V16C14 14.8954 14.8954 14 16 14H18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9 6L9 8C9 9.10457 8.10457 10 7 10L5 10" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M5 14L7 14C8.10457 14 9 14.8954 9 16L9 18" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M18 10L16 10C14.8954 10 14 9.10457 14 8L14 6" stroke="#0F2744" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div className="flex-grow-1 page-content-wrap d-flex align-items-center">
            <div className="container">
              <div className="question-wrapper">
                <div className="heading">
                  <h3>Q{questionIndex}. {questionText} </h3>
                </div>
                <div className="field-wrapper opinion-scale-number d-flex align-items-center justify-content-center">
                  {/*Number Scale*/}
                  {values?.icon === 1 && <div className="icon-counter d-flex justify-content-center">
                    <div className="icon-counter-wrapper text-center selected">
                      <div className="couter-wrap d-flex justify-content-center align-items-center">
                        <input type="radio" name="number-counter" id="num-1" />
                        1</div>
                      <label htmlFor='num-1' className="text-wrap">Worst</label>
                    </div>
                    <div className="icon-counter-wrapper text-center selected">
                      <div className="couter-wrap d-flex justify-content-center align-items-center">
                        <input type="radio" name="number-counter" id="num-2" /> 2</div>
                      <label htmlFor='num-2' className="text-wrap">Bad</label>
                    </div>
                    <div className="icon-counter-wrapper text-center selected">
                      <div className="couter-wrap d-flex justify-content-center align-items-center">
                        <input type="radio" name="number-counter" id="num-3" defaultChecked />3</div>
                      <label htmlFor='num-3' className="text-wrap">Neutral</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="couter-wrap d-flex justify-content-center align-items-center">
                        <input type="radio" name="number-counter" id="num-4" />
                        4</div>
                      <label htmlFor='num-4' className="text-wrap">Good</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="couter-wrap d-flex justify-content-center align-items-center">
                        <input type="radio" name="number-counter" id="num-5" />5</div>
                      <label htmlFor='num-5' className="text-wrap">Best</label>
                    </div>
                  </div>}

                  {/*Star Scale */}
                  {values?.icon === 2 && <div className="icon-counter d-flex justify-content-center">
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap stars selected">
                        <input type="radio" name="number-counter" id="star-1" />
                        <Svg name="star" />
                      </div>
                      <label htmlFor="star-1" className="text-wrap">Worst</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap stars selected">
                        <input type="radio" name="number-counter" id="star-2" />
                        <Svg name="star" />
                      </div>
                      <label htmlFor="star-2" className="text-wrap">Bad</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap stars selected">
                        <input type="radio" name="number-counter" id="star-3" defaultChecked />
                        <Svg name="star" />
                      </div>
                      <label htmlFor="star-3" className="text-wrap">Neutral</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap stars">
                        <input type="radio" name="number-counter" id="star-4" />
                        <Svg name="star" />
                      </div>
                      <label htmlFor="star-4" className="text-wrap">Good</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap stars">
                        <input type="radio" name="number-counter" id="star-5" />
                        <Svg name="star" />
                      </div>
                      <label htmlFor="star-5" className="text-wrap">Best</label>
                    </div>
                  </div>}

                  {/*Thumbs Up Scale */}
                  {values?.icon === 3 && <div className="icon-counter d-flex justify-content-center">
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap like selected">
                        <input type="radio" name="number-counter" id="like-1" />

                      </div>
                      <label htmlFor="like-1" className="text-wrap">Worst</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap like selected">
                        <input type="radio" name="number-counter" id="like-2" />

                      </div>
                      <label htmlFor="like-2" className="text-wrap">Bad</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap like selected">
                        <input type="radio" name="number-counter" id="like-3" defaultChecked />

                      </div>
                      <label htmlFor="like-3" className="text-wrap">Neutral</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap like">
                        <input type="radio" name="number-counter" id="like-4" />
                      </div>
                      <label htmlFor="like-4" className="text-wrap">Good</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <div className="start-wrap like">
                        <input type="radio" name="number-counter" id="like-5" />
                      </div>
                      <label htmlFor="like-5" className="text-wrap">Best</label>
                    </div>
                  </div>}

                  {/*Smily Up Scale */}
                  {values?.icon === 4 && <div className="icon-counter smily-counter d-flex justify-content-center">
                    <div className="icon-counter-wrapper text-center">
                      <input type="radio" name="number-counter" id="smily-1" />
                      <div className="start-wrap smily-1">
                        <Svg name="Smily-Worst" />
                      </div>
                      <label htmlFor="smily-1" className="text-wrap">Worst</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <input type="radio" name="number-counter" id="smily-2" />
                      <div className="start-wrap smily-2 ">
                        <Svg name="Smily-Bad" />
                      </div>
                      <label htmlFor="smily-2" className="text-wrap">Bad</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <input type="radio" name="number-counter" id="smily-3" defaultChecked />
                      <div className="start-wrap smily-3">
                        <Svg name="Smily-Neutral" />
                      </div>
                      <label htmlFor="smily-3" className="text-wrap">Neutral</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <input type="radio" name="number-counter" id="smily-4" />
                      <div className="start-wrap smily-4">
                        <Svg name="Smily-Good" />
                      </div>
                      <label htmlFor="smily-4" className="text-wrap">Good</label>
                    </div>
                    <div className="icon-counter-wrapper text-center">
                      <input type="radio" name="number-counter" id="smily-5" />
                      <div className="start-wrap smily-4">
                        <Svg name="Smily-Best" />
                      </div>
                      <label htmlFor="smily-5" className="text-wrap">Best</label>
                    </div>
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>}


        <div className="opinion-scale bottom-buttons-wrap bottomBtns d-flex align-items-center justify-content-between">
          {collapseMode === collapseModes?.edit &&
            <div className="select-type-words d-flex align-items-center">
              <div className="select-type d-flex align-items-center">
                <div className="title"><h5>Start</h5></div>
                <div className="checkbox-custom-wrap d-flex align-items-center">
                  <select className="form-control"
                    value={values?.range.start}
                    onChange={(e) => { handleChangeRange(e, 'start') }}
                    disabled={window.modulePermissions.M11.edit != 1} >
                    <option vlaue={1}>1</option>
                    <option vlaue={2}>2</option>
                    <option vlaue={3}>3</option>
                    <option vlaue={4}>4</option>
                    <option vlaue={5}>5</option>
                  </select>
                </div>
              </div>
              <div className="select-type d-flex align-items-center">
                <div className="title"><h5>End</h5></div>
                <select className="form-control"
                  value={values?.range.end}
                  onChange={(e) => { handleChangeRange(e, 'end') }}
                  disabled={window.modulePermissions.M11.edit != 1} >
                  <option vlaue={1}>1</option>
                  <option vlaue={2}>2</option>
                  <option vlaue={3}>3</option>
                  <option vlaue={4}>4</option>
                  <option vlaue={5}>5</option>
                </select>
              </div>
              <div className="select-type d-flex align-items-center">
                <div className="title"><h5>Choose an icon</h5></div>
                <div className="field-wrapper yes-no-inputs d-flex align-items-center">

                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioIcon"
                      id={`flexRadioIcon1${questionId}`}
                      checked={values?.icon === 1}
                      onChange={() => handleChangeIcon('icon', 1)}
                      disabled={window.modulePermissions.M11.edit != 1}
                    />
                    <label
                      className="form-check-label d-flex align-items-center justify-content-center"
                      htmlFor={`flexRadioIcon1${questionId}`}
                    > <svg width={26} height={26} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15.108 16.184V17H10.5V16.184H12.342V10.322C12.342 10.146 12.348 9.968 12.36 9.788L10.83 11.102C10.778 11.146 10.726 11.174 10.674 11.186C10.622 11.194 10.574 11.194 10.53 11.186C10.486 11.178 10.444 11.162 10.404 11.138C10.368 11.114 10.34 11.088 10.32 11.06L9.984 10.598L12.546 8.384H13.416V16.184H15.108Z" fill="#728095" /> <circle cx={13} cy={13} r={12} stroke="#728095" strokeWidth="1.5" /> </svg> </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioIcon"
                      id={`flexRadioIcon2${questionId}`}
                      checked={values?.icon === 2}
                      onChange={() => handleChangeIcon('icon', 2)}
                      disabled={window.modulePermissions.M11.edit != 1}
                    />
                    <label
                      className="form-check-label d-flex align-items-center justify-content-center"
                      htmlFor={`flexRadioIcon2${questionId}`}> <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M13.7299 3.51063L15.4899 7.03063C15.7299 7.52063 16.3699 7.99063 16.9099 8.08063L20.0999 8.61062C22.1399 8.95062 22.6199 10.4306 21.1499 11.8906L18.6699 14.3706C18.2499 14.7906 18.0199 15.6006 18.1499 16.1806L18.8599 19.2506C19.4199 21.6806 18.1299 22.6206 15.9799 21.3506L12.9899 19.5806C12.4499 19.2606 11.5599 19.2606 11.0099 19.5806L8.01991 21.3506C5.87991 22.6206 4.57991 21.6706 5.13991 19.2506L5.84991 16.1806C5.97991 15.6006 5.74991 14.7906 5.32991 14.3706L2.84991 11.8906C1.38991 10.4306 1.85991 8.95062 3.89991 8.61062L7.08991 8.08063C7.61991 7.99063 8.25991 7.52063 8.49991 7.03063L10.2599 3.51063C11.2199 1.60063 12.7799 1.60063 13.7299 3.51063Z" stroke="#728095" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /> </svg> </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioIcon"
                      id={`flexRadioIcon3${questionId}`}
                      checked={values?.icon === 3}
                      onChange={() => handleChangeIcon('icon', 3)}
                      disabled={window.modulePermissions.M11.edit != 1}
                    />
                    <label
                      className="form-check-label d-flex align-items-center justify-content-center"
                      htmlFor={`flexRadioIcon3${questionId}`}> <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.47998 18.3505L10.58 20.7505C10.98 21.1505 11.88 21.3505 12.48 21.3505H16.28C17.48 21.3505 18.78 20.4505 19.08 19.2505L21.48 11.9505C21.98 10.5505 21.08 9.35046 19.58 9.35046H15.58C14.98 9.35046 14.48 8.85046 14.58 8.15046L15.08 4.95046C15.28 4.05046 14.68 3.05046 13.78 2.75046C12.98 2.45046 11.98 2.85046 11.58 3.45046L7.47998 9.55046" stroke="#728095" strokeWidth="1.5" strokeMiterlimit={10} /> <path d="M2.37988 18.3504V8.55039C2.37988 7.15039 2.97988 6.65039 4.37988 6.65039H5.37988C6.77988 6.65039 7.37988 7.15039 7.37988 8.55039V18.3504C7.37988 19.7504 6.77988 20.2504 5.37988 20.2504H4.37988C2.97988 20.2504 2.37988 19.7504 2.37988 18.3504Z" stroke="#728095" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /> </svg> </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioIcon"
                      id={`flexRadioIcon4${questionId}`}
                      checked={values?.icon === 4}
                      onChange={() => handleChangeIcon('icon', 4)}
                      disabled={window.modulePermissions.M11.edit != 1}
                    />
                    <label
                      className="form-check-label d-flex align-items-center justify-content-center"
                      htmlFor={`flexRadioIcon4${questionId}`}
                    >
                      <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 9C0.5 4.31339 4.31339 0.5 9 0.5C13.6866 0.5 17.5 4.31339 17.5 9C17.5 13.6866 13.6866 17.5 9 17.5C4.31339 17.5 0.5 13.6866 0.5 9ZM17 9C17 4.57261 13.4274 1 9 1C4.57261 1 1 4.57261 1 9C1 13.4274 4.57261 17 9 17C13.4274 17 17 13.4274 17 9ZM5.18306 6.68306C5.30027 6.56585 5.45924 6.5 5.625 6.5C5.79076 6.5 5.94973 6.56585 6.06694 6.68306L6.4205 6.3295L6.06694 6.68306C6.18415 6.80027 6.25 6.95924 6.25 7.125C6.25 7.29076 6.18415 7.44973 6.06694 7.56694L6.4205 7.9205L6.06694 7.56694C5.94973 7.68415 5.79076 7.75 5.625 7.75C5.45924 7.75 5.30027 7.68415 5.18306 7.56694L4.8295 7.9205L5.18306 7.56694C5.06585 7.44973 5 7.29076 5 7.125C5 6.95924 5.06585 6.80027 5.18306 6.68306L4.8295 6.3295L5.18306 6.68306ZM11.9331 6.68306C12.0503 6.56585 12.2092 6.5 12.375 6.5C12.5408 6.5 12.6997 6.56585 12.8169 6.68306C12.9342 6.80027 13 6.95924 13 7.125C13 7.29076 12.9342 7.44973 12.8169 7.56694C12.6997 7.68415 12.5408 7.75 12.375 7.75C12.2092 7.75 12.0503 7.68415 11.9331 7.56694C11.8158 7.44973 11.75 7.29076 11.75 7.125C11.75 6.95924 11.8158 6.80027 11.9331 6.68306ZM4.52267 12.1698L4.94788 11.9223C5.35896 12.4952 5.88815 12.9759 6.50183 13.3307C7.26114 13.7698 8.12289 14.0007 9 14C9.87711 14.0007 10.7389 13.7698 11.4982 13.3307C12.1119 12.9759 12.641 12.4952 13.0521 11.9223L13.4773 12.1698C12.4819 13.5792 10.8492 14.5 9 14.5C7.15081 14.5 5.51813 13.5792 4.52267 12.1698Z" fill="black" stroke="#728095" />
                      </svg>
                    </label>
                  </div>

                </div>
              </div>
            </div>
          }

          <div className="accoriancon-right d-flex align-items-center flex-wrap justify-content-end">
            {collapseMode === collapseModes?.edit && <>
              <div className="action-wrapper d-flex accordianSwitch">
                < Switch
                  type='dense'
                  color='default'
                  disabled={window.modulePermissions.M11.edit != 1}
                  label='Required'
                  fill={false}
                  rtl={false}
                  leftPosition={false}
                  className='SwitchCustom'
                  checked={Number(question?.required) === 1}
                  value={'su_is_required'}
                  onChange={window.modulePermissions.M11.edit == 1 ? handleIsRequired : undefined}
                />
              </div>
              <div className="action-wrapper d-flex accordianSwitch ms-3">
                < Switch
                  type='dense'
                  color='default'
                  disabled={window.modulePermissions.M11.edit != 1}
                  label='Score'
                  fill={false}
                  rtl={false}
                  leftPosition={false}
                  className='SwitchCustom'
                  checked={Number(question?.isScore) === 1}
                  value={'su_is_score'}
                  onChange={window.modulePermissions.M11.edit == 1 ? handleIsScore : undefined}
                />
                {/* <div className="tooltipInit ms-2 custom-callout-init">
                  <img src={iicon} alt="info" />
                  <div className='infobox custom-callout'>
                    < Callout
                      type='def'
                      view='outlined'
                      color='primary'
                      title='Score'
                      icon={<Svg name="primary-info" />}
                    >
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum eleifend arcu laoreet elit maximus, eu accumsan tortor suscipit.
                    </Callout >

                  </div>
                </div> */}
              </div>
            </>
            }

            {window.modulePermissions.M11.edit == 1 && (
            <div className="switch-button d-flex align-items-center">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`deletecheck-q${questionId}`}
                  id={`edit-view-q${questionId}`}
                  checked={collapseMode === collapseModes.edit}
                  onChange={() => handleViewChange(collapseModes.edit)}
                />
                <label className="form-check-label" htmlFor={`edit-view-q${questionId}`}>
                  Edit
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name={`deletecheck-q${questionId}`}
                  id={`preview-view-q${questionId}`}
                  checked={collapseMode === collapseModes.preview}
                  onChange={() => handleViewChange(collapseModes.preview)}
                />
                <label className="form-check-label" htmlFor={`preview-view-q${questionId}`}>
                  Preview
                </label>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </div >
  )
}

export default OpinionScalePreview